/* eslint-disable */
import React from 'react'
import { CommonSizeArrows } from '../report_components/MoneyHelpers'
import { sumTrailing12MonthsValues } from '../monthly/monthy_analysis_table_trailing12_calculations';

const monthlyCommonSized = (object, passedCalcs, selectedYear) => {
    const reducedArray = object ? Object.values(object).reduce((a, b) => a + b, 0) : 0
    const totalRevenue = Object.values(passedCalcs?.['total_revenue']?.[selectedYear] || {}).reduce((a, b) => a + b, 0)
    if (totalRevenue !== 0) {
        return (reducedArray / totalRevenue) * 100
    } else {
        return undefined
    }
}

const commonSizeArrowsHelper = (monthlyCalcs, propsYou, propsComparedTo, passedCalcs, keyArrBuilder, displayColumnsBy, selectedYear = null, compareYear = null) => {
    let arrow

    if (displayColumnsBy === 'Months') {
        const totalRevenueYou = Object.values(monthlyCalcs?.['total_revenue']?.[selectedYear] || {}).reduce((a, b) => a + b, 0)
        const totalRevenueComparedTo = Object.values(passedCalcs?.['total_revenue']?.[compareYear] || {}).reduce((a, b) => a + b, 0)
        if (totalRevenueYou !== 0 && totalRevenueComparedTo !== 0) {
            const reducedArrayYou = Object.values(propsYou).reduce((a, b) => a + b, 0)
            const reducedArrayComparedTo = propsComparedTo ? Object.values(propsComparedTo).reduce((a, b) => a + b, 0) : 0

            const you = (reducedArrayYou / totalRevenueYou) * 100
            const compareTo = (reducedArrayComparedTo / totalRevenueComparedTo) * 100
            arrow = CommonSizeArrows(you, compareTo, keyArrBuilder)
        } else {
            return arrow = ''
        }
    } else {
        arrow = CommonSizeArrows(propsYou, propsComparedTo, keyArrBuilder)
    }
    if (arrow === 'better' || arrow === 'best') {
        arrow = <p className='common-size-arrow-green' style={{ margin: 0, color: 'green' }}>&#9650;</p>
    } else if (arrow === 'worse' || arrow === 'worst') {
        arrow = <p className='common-size-arrow-red' style={{ margin: 0, color: 'red' }}>&#9660;</p>
    } else {
        arrow = ''
    }

    return arrow;
}

const getYTDMonths = (data, ytdMonths) => {
    if (!data || !Array.isArray(ytdMonths)) return [];
    return ytdMonths.map((m) => data[m]);
};

const reduceYTD = (monthlyCalcs, who, key, year, ytdMonths, commonSize = false) => {
    let answer = monthlyCalcs?.[who]?.[key]?.[year] ? getYTDMonths(monthlyCalcs[who]?.[key]?.[year], ytdMonths).reduce((a, b) => a + b, 0) : undefined
    let totalRevenue = monthlyCalcs?.[who]?.['total_revenue']?.[year] ? getYTDMonths(monthlyCalcs[who]?.['total_revenue']?.[year], ytdMonths).reduce((a, b) => a + b, 0) : undefined
    answer && commonSize && totalRevenue ? answer = (answer / totalRevenue) * 100 : answer

    return answer;
}


// this is the year to date array builder section YTD and monthly
// ytd calcs come like this: {you: {roa: { 2020: {1: 1.1270120245297484, 2: null}, 2019: {1: 1.1270120245297484, 2: null} }, avg: {}},
// for ytd filter we want the trailing twelve for the last month available
// year to date only ever compares with peers, there is no YOY filter, because it already is YOY
// if we're displaying years 2019 and 2020, we'll need full years back to 2017
// 2020/2019/2018
// 2019/2018/2017

const peopleCustomersT12Metrics = (peopleOrCustomers, metricName, monthlyCalcs, year1 = null, year2 = null, year3 = null, ytd = false, ytdMonths = [], type = 'you') => {
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    let returnObj = {};

    switch (metricName) {
        // People methods for report summary
        case 'total_revenue_per_employee':
        case 'revenue_per_customer':
            returnObj[metricName] = pcNumeratorArDividedByDenominator(months, peopleOrCustomers, monthlyCalcs, ['total_revenue'], 'numClientsEmpl', year1, year2, ytd, ytdMonths)
            break;
        case 'operating_expenses_net_income_per_employee':
        case 'operating_expenses_net_income_per_customer':
            returnObj[metricName] = pcNumeratorArDividedByDenominator(months, peopleOrCustomers, monthlyCalcs, ['operating_expenses_net_income'], 'numClientsEmpl', year1, year2, ytd, ytdMonths)
            break;
        case 'turnover_rate':
        case 'total_revenue':
        case 'gross_profit':
        case 'total_number_of_customers':
        case 'total_number_of_employees':
        case 'operating_expenses_net_income':
            returnObj[metricName] = monthlyCalcs && monthlyCalcs.hasOwnProperty(metricName) ? monthlyCalcs[metricName]?.[year1] : undefined
            break;
        case 'sum_compensation_per_employee':
            returnObj[metricName] = pcNumeratorArDividedByDenominator(months, peopleOrCustomers, monthlyCalcs, ['sum_compensation'], 'numClientsEmpl', year1, year2, ytd, ytdMonths)
            break;
        case 'sum_taxes_and_benefits_per_employee':
            returnObj[metricName] = pcNumeratorArDividedByDenominator(months, peopleOrCustomers, monthlyCalcs, ['sum_taxes_and_benefits'], 'numClientsEmpl', year1, year2, ytd, ytdMonths)
            break;
        case 'sum_payroll_per_employee':
            returnObj[metricName] = pcNumeratorArDividedByDenominator(months, peopleOrCustomers, monthlyCalcs, ['sum_payroll'], 'numClientsEmpl', year1, year2, ytd, ytdMonths)
            break;
        case 'sum_health_insurance_per_employee':
            returnObj[metricName] = pcNumeratorArDividedByDenominator(months, peopleOrCustomers, monthlyCalcs, ['sum_health_insurance'], 'numClientsEmpl', year1, year2, ytd, ytdMonths)
            break;
        case 'sum_retirement_per_employee':
            returnObj[metricName] = pcNumeratorArDividedByDenominator(months, peopleOrCustomers, monthlyCalcs, ['sum_retirement'], 'numClientsEmpl', year1, year2, ytd, ytdMonths)
            break;
        case 'training_per_employee':
            returnObj[metricName] = pcNumeratorArDividedByDenominator(months, peopleOrCustomers, monthlyCalcs, ['training'], 'numClientsEmpl', year1, year2, ytd, ytdMonths)
            break;
        case 'number_of_employees_who_left':
            returnObj[metricName] = numberEmployeesWhoLeft(months, monthlyCalcs, year1, ytd, ytdMonths)
            break;
        case 'cost_of_turnover':
            break;

        // People methods for KPIs
        case 'sum_compensation_growth_rate':
        case 'sum_taxes_and_benefits_growth_rate':
        case 'sum_subcontractors_growth_rate':
            returnObj[metricName] = pcGrowthRate(months, monthlyCalcs, metricName, year1, year2, year3, ytd, ytdMonths)
            break;
        case 'average_wages_and_salaries':
            returnObj[metricName] = pcNumeratorArDividedByDenominator(months, peopleOrCustomers, monthlyCalcs, ['labor_cogs_compensation', 'labor_cogs_taxes_and_benefits', 'total_compensation', 'total_taxes_and_benefits'], 'numClientsEmpl', year1, year2, ytd, ytdMonths)
            break;
        case 'average_benefits':
            returnObj[metricName] = pcNumeratorArDividedByDenominator(months, peopleOrCustomers, monthlyCalcs, ['labor_cogs_taxes_and_benefits', 'total_taxes_and_benefits'], 'numClientsEmpl', year1, year2, ytd, ytdMonths)
            break;

        // Customers methods for report summary
        case 'gross_profit_per_customer':
            returnObj[metricName] = pcNumeratorArDividedByDenominator(months, peopleOrCustomers, monthlyCalcs, ['gross_profit'], 'numClientsEmpl', year1, year2, ytd, ytdMonths)
            break;
        case 'customer_roi':
            returnObj[metricName] = pcCustomerROI(months, monthlyCalcs, year1, year2, year3, ytd, ytdMonths)
            break;
        case 'total_customer_costs_common_size_revenue':
            returnObj[metricName] = pcNumeratorArDividedByDenominator(months, peopleOrCustomers, monthlyCalcs, ['total_customer_costs'], 'total_revenue', year1, year2, ytd, ytdMonths)
            break;
        case 'number_of_new_customers_needed_to_maintain_growth':
            returnObj[metricName] = pcNumberCustomersNeededMaintainGrowth(months, monthlyCalcs, year1, year2, year3, ytd, ytdMonths)
            break;

        default:
            returnObj[metricName] = undefined
            break;
    }
    return returnObj
}

const numberEmployeesWhoLeft = (months, monthlyCalcs, year1, ytd = false, ytdMonths = []) => {
    let returnObj = {};
    if (monthlyCalcs) {
        let turnoverRate = monthlyCalcs.hasOwnProperty('turnover_rate') ? monthlyCalcs['turnover_rate']?.[year1] : {}
        let numberEmployees = monthlyCalcs.hasOwnProperty('total_number_of_employees') ? monthlyCalcs['total_number_of_employees']?.[year1] : {}
        const relevantMonths = ytd ? ytdMonths : months;

        if (_.isEmpty(turnoverRate) || _.isEmpty(numberEmployees)) {
            return undefined;
        }

        relevantMonths.forEach((m) => {
            const rate = turnoverRate[m];
            const num = numberEmployees[m];

            if (_.isNumber(rate) && _.isNumber(num)) {
                returnObj[m] = rate * num;
            } else {
                returnObj[m] = null;
            }
        });
    }
    return returnObj
}

const pcNumberCustomersNeededMaintainGrowth = (months, monthlyCalcs, year1, year2, year3, ytd = false, ytdMonths = []) => {
    const relevantMonths = ytd ? ytdMonths : months;
    let returnObj = {};
    if (monthlyCalcs) {
        let sumT12TotalRev = monthlyCalcs.hasOwnProperty('total_revenue') ? sumTrailing12MonthsValues('total_revenue', monthlyCalcs, year1, year2, false, null, ytd, ytdMonths) : {}
        let totRevGrowthRateT12 = pcGrowthRate(months, monthlyCalcs, 'total_revenue', year1, year2, year3, ytd, ytdMonths)
        let revPerT12 = pcNumeratorArDividedByDenominator(months, 'customers', monthlyCalcs, ['total_revenue'], 'numClientsEmpl', year1, year2, ytd, ytdMonths)

        if (sumT12TotalRev && totRevGrowthRateT12 && revPerT12) {
            relevantMonths.forEach((m, i) => {
                returnObj[i + 1] = (sumT12TotalRev[i + 1] * totRevGrowthRateT12[i + 1]) / revPerT12[i + 1]
            })
            return returnObj
        } else returnObj = undefined
    }

    return returnObj
    // (total_revenue * total_revenue_growth_rate) / revenue_per_customer
}


const pcCustomerROI = (months, monthlyCalcs, year1, year2, year3, ytd = false, ytdMonths = []) => {
    const relevantMonths = ytd ? ytdMonths : months;
    let returnObj = {};
    if (monthlyCalcs) {
        let sumT12TotalRev = monthlyCalcs.hasOwnProperty('total_revenue') ? sumTrailing12MonthsValues('total_revenue', monthlyCalcs, year1, year2, false, null, ytd, ytdMonths) : {}
        let sumT12TotalRevPreviousDecember = monthlyCalcs.hasOwnProperty('total_revenue') ? sumTrailing12MonthsValues('total_revenue', monthlyCalcs, year2, year3, false, null, ytd, ytdMonths) : {}
        let sumT12TotCusCosts = monthlyCalcs.hasOwnProperty('total_customer_costs') ? sumTrailing12MonthsValues('total_customer_costs', monthlyCalcs, year1, year2, false, null, ytd, ytdMonths) : {}

        if (!_.isEmpty(sumT12TotalRev) && !_.isEmpty(sumT12TotCusCosts)) {
            relevantMonths.forEach((month, i) => {
                if (i === 0) {
                    returnObj[i + 1] = ((sumT12TotalRev[1] - sumT12TotalRevPreviousDecember[12]) - (sumT12TotCusCosts[1])) / sumT12TotCusCosts[1]
                } else {
                    returnObj[i + 1] = ((sumT12TotalRev[i + 1] - sumT12TotalRev[i]) - (sumT12TotCusCosts[i + 1])) / sumT12TotCusCosts[i + 1]
                }
            });

            return returnObj;
        }
    }
    return returnObj;
}


const pcGrowthRate = (months, monthlyCalcs, metricName, year1, year2, year3, ytd = false, ytdMonths = []) => {
    const relevantMonths = ytd ? ytdMonths : months;
    let returnObj = {};
    let metricString = ''

    switch (metricName) {
        case 'sum_compensation_growth_rate':
            metricString = 'sum_compensation'
            break;
        case 'sum_taxes_and_benefits_growth_rate':
            metricString = 'sum_taxes_and_benefits'
            break;
        case 'sum_subcontractors_growth_rate':
            metricString = 'sum_subcontractors'
            break;
        default:
            metricString = metricName
            break;
    }

    let numeratorDenominatorSumT12 = sumTrailing12MonthsValues(metricString, monthlyCalcs, year1, year2, false, null, ytd, ytdMonths)
    let forJanDenominatorSumT12 = sumTrailing12MonthsValues(metricString, monthlyCalcs, year2, year3, false, null, ytd, ytdMonths)

    if (numeratorDenominatorSumT12) {
        relevantMonths.forEach((month, i) => {
            let monthNumber = i + 1

            if (monthNumber === 1) {
                returnObj[i + 1] = (numeratorDenominatorSumT12[1] / forJanDenominatorSumT12[12]) - 1
            } else {
                returnObj[i + 1] = (numeratorDenominatorSumT12[monthNumber] / numeratorDenominatorSumT12[monthNumber - 1]) - 1
            }
        })
        return returnObj
    } else returnObj = undefined

    return returnObj
}


const pcNumeratorArDividedByDenominator = (months, peopleOrCustomers, monthlyCalcs, numeratorAr, denominator, year1 = null, year2 = null, ytd = false, ytdMonths = []) => {
    let numeratorSumT12 = {};
    let denominatorSumT12;
    let returnObj = {};

    if (monthlyCalcs) {
        months.forEach((month, i) => numeratorSumT12[i + 1] = 0)
        numeratorAr.forEach(metric => {
            let metricLoop = monthlyCalcs.hasOwnProperty(metric) ? sumTrailing12MonthsValues(metric, monthlyCalcs, year1, year2, false, null, ytd, ytdMonths) : 0
            if (metricLoop) {
                Object.values(metricLoop).forEach((v, i) => {
                    numeratorSumT12[i + 1] += v
                })
            }
        })

        if (denominator === 'numClientsEmpl' && peopleOrCustomers === 'people') {
            denominatorSumT12 = monthlyCalcs.hasOwnProperty('total_number_of_employees') ? monthlyCalcs['total_number_of_employees']?.[year1] : 0
        } else if (denominator == 'numClientsEmpl' && peopleOrCustomers == 'customers') {
            denominatorSumT12 = monthlyCalcs.hasOwnProperty('total_number_of_customers') ? monthlyCalcs['total_number_of_customers']?.[year1] : 0
        } else {
            denominatorSumT12 = monthlyCalcs.hasOwnProperty(denominator) ? sumTrailing12MonthsValues(denominator, monthlyCalcs, year1, year2, false, null, ytd, ytdMonths) : 0
        }

        months.forEach((month, i) => {
            returnObj[i + 1] = denominatorSumT12[i + 1] ? numeratorSumT12[i + 1] / denominatorSumT12[i + 1] : 0
        })
    }

    return returnObj
}

const peersAnalysisPerCustomerVals = (key, year, vals) => {
    let finalValue = null
    let firstPartKey = key.substring(0, key.length - 13)
    if (key === 'revenue_per_customer') {
        finalValue = vals['total_revenue'][year] / vals['total_number_of_customers'][year]
    } else if (key.includes('_per_customer')) {
        let totalVal = vals[firstPartKey + '_common_size_revenue'][year] * vals['total_revenue'][year]
        finalValue = totalVal / vals['total_number_of_customers'][year]
    } else {
        finalValue = vals[key + '_common_size_revenue'][year] * vals['total_revenue'][year]
    }
    return finalValue
}

export { monthlyCommonSized, commonSizeArrowsHelper, reduceYTD, peopleCustomersT12Metrics, peersAnalysisPerCustomerVals }